import React, { useState } from 'react';
import './app.css';

import MapComponent from './MapComponent/MapComponent.tsx';
import BottomBar from './BottomBar.tsx';
import LeftBar from './LeftBar.tsx';
import BurgerMenu from './BurgerMenu.tsx';
import { useLanguage } from './context/LanguageContext.tsx';

function App() {
    const currentYear = new Date().getFullYear();

    const [checkedItems, setCheckedItems] = useState({
        vegetationSeason: false,
        vegetationSeasonEnd: false,
        vegetationIndex: false,
        meteo: false,
        archiveData: false,
    });

    const [temperatureThreshold, setTemperatureThreshold] = useState(5);
    const [selectedBand, setSelectedBand] = useState<string | null>(null);
    const [selectedYear, setSelectedYear] = useState<number>(currentYear);
    const [selectedDays, setSelectedDays] = useState<number>(5);
    const [refreshKey, setRefreshKey] = useState(0);

    const [averageTemperatures, setAverageTemperatures] = useState<number[]>([]);
    const [temperatureDays, setTemperatureDays] = useState<number[]>([]);

    const [selectedProduct, setSelectedProduct] = useState<string>('combinedProduct');
    const [selectedVelicina, setSelectedVelicina] = useState<string | null>(null);
    const [selectedOption, setSelectedOption] = useState<string | null>(null);

    const { language, setLanguage } = useLanguage();

    const handleFilterChange = (newCheckedItems: { [key: string]: boolean }) => {
        setCheckedItems(newCheckedItems);
        if (newCheckedItems.vegetationSeason) setSelectedVelicina('vegetationSeason');
        else if (newCheckedItems.vegetationSeasonEnd) setSelectedVelicina('vegetationSeasonEnd');
        else if (newCheckedItems.seasonLength) setSelectedVelicina('seasonLength');
        else setSelectedVelicina(null);
    };

    const handleProductChange = (product: string) => {
        setSelectedProduct(product);
        setRefreshKey((prev) => prev + 1);
    };

    return (
        <div className="app-container">
            <div className="top-section">
                <LeftBar
                    checkedItems={checkedItems}
                    onFilterChange={handleFilterChange}
                    onThresholdChange={setTemperatureThreshold}
                    onBandChange={setSelectedBand}
                    onYearChange={(year) => {
                        setSelectedYear(year);
                        setRefreshKey((prev) => prev + 1);
                    }}
                    onDaysChange={setSelectedDays}
                    onProductChange={handleProductChange}
                    selectedYear={selectedYear}
                />

                <div className="map-container">
                    <div className="icon-bar">
                        <img
                            src="/flags/flag-cz.png"
                            alt="Čeština"
                            className={`icon-button ${language === 'cz' ? 'active' : ''}`}
                            onClick={() => setLanguage('cz')}
                        />
                        <img
                            src="/flags/flag-gb.png"
                            alt="English"
                            className={`icon-button ${language === 'en' ? 'active' : ''}`}
                            onClick={() => setLanguage('en')}
                        />
                        <BurgerMenu
                            selectedProduct={selectedProduct}
                            selectedYear={selectedYear}
                            selectedDays={selectedDays}
                            temperatureThreshold={temperatureThreshold}
                            checkedItems={checkedItems}
                            language={language}
                            selectedOption={selectedOption}
                            setSelectedOption={setSelectedOption}
                        />
                    </div>
                    <MapComponent
                        checkedItems={checkedItems}
                        temperatureThreshold={temperatureThreshold}
                        selectedBand={selectedBand}
                        selectedYear={selectedYear}
                        selectedDays={selectedDays}
                        selectedProduct={selectedProduct}
                        selectedVelicina={selectedVelicina}
                        setAverageTemperatures={(temps, days) => {
                            setAverageTemperatures(temps);
                            setTemperatureDays(days);
                        }}
                        refreshKey={refreshKey}
                        language={language}
                        selectedOption={selectedOption}
                    />
                </div>
            </div>

            <BottomBar
                averageTemperatures={averageTemperatures}
                temperatureDays={temperatureDays}
                language={language}
            />
        </div>
    );
}

export default App;
